import { Partner, UsufructData } from 'types';

export const createDividends = (
  partners: Partner[],
  societyActualSharesCount: number,
  totalAmount: number,
  usufructDataByPartner: { [key: string]: UsufructData[] } = {},
  retentionPercentage: number = 0
) =>
  partners.map((partner) => {
    const usufructData = usufructDataByPartner[partner._id] || [];

    const usufructSharesCount = usufructData.reduce((acc, data) => {
      const sharesCount = (data.sharesCount * data.percentage) / 100 || 0;
      return acc + (data.isMainCoOwner ? -sharesCount : sharesCount);
    }, 0);

    const partnerSharesCount =
      (partner.sharesCount?.actual || 0) + usufructSharesCount;

    const ndPercent =
      ((partner.sharesCount?.actual || 0) / societyActualSharesCount) * 100 ||
      0;

    const ndPercentWithUsufruct =
      ((partnerSharesCount || 0) / societyActualSharesCount) * 100 || 0;

    const dividendAmount = (ndPercentWithUsufruct * totalAmount) / 100 || 0;

    const retentionAmount = (dividendAmount * retentionPercentage) / 100 || 0;

    return {
      name: partner?.name,
      ndPercent,
      dividendAmount,
      retentionAmount,
      usufructData,
    };
  });
